import axios from 'axios'

// AXIOS PLATFORM BASE CONFIGURATION
export const HTTP_PLATFORM = axios.create({
  baseURL: process.env.VUE_APP_PLATFORM
})

// Alter defaults after HTTP_PLATFORM has been created
if (sessionStorage.sessionToken) {
  HTTP_PLATFORM.defaults.headers.common.Authorization = 'Bearer ' + sessionStorage.sessionToken
}
